var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8748 12.25H31.1248M11.2998 9.79996V39.2C11.2998 41.9062 13.4936 44.1 16.1998 44.1H33.7998C36.506 44.1 38.6998 41.9062 38.6998 39.2V9.79999C38.6998 7.0938 36.506 4.9 33.7998 4.89999L16.1998 4.89996C13.4936 4.89996 11.2998 7.09377 11.2998 9.79996ZM24.9998 34.3H25.1734V34.457H24.9998V34.3Z",
    stroke: "#00123A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/PhoneNumber.1eadd3635737b9b8496ce8e070ec2558.svg";
export { ForwardRef as ReactComponent };